<nav
  class="pointer-events-auto fixed inset-x-0 bottom-0 z-40 overflow-visible border-t border-gray-200/70 bg-white pb-[calc(0.375rem+env(safe-area-inset-bottom))] shadow-[0_-4px_24px_rgba(16,24,40,0.06)]"
  [attr.aria-label]="'mobile.tabbar.primaryAria' | translate"
>
  @if (centerTab; as book) {
    <a
      [routerLink]="book.route"
      class="absolute left-1/2 top-0 z-10 -translate-x-1/2 -translate-y-1/2 no-underline"
      [attr.aria-label]="book.labelKey | translate"
    >
      <span
        class="flex size-[4.25rem] flex-col items-center justify-center gap-0.5 rounded-full bg-[#2d3e33] text-[0.625rem] font-semibold leading-none text-white shadow-[0_8px_24px_rgba(45,62,51,0.38)] [&_ion-icon]:text-[1.375rem] [&_ion-icon]:text-white"
      >
        <ion-icon [name]="book.icon"></ion-icon>
        <span>{{ book.labelKey | translate }}</span>
      </span>
    </a>
  }

  <div class="grid grid-cols-5 items-end px-0.5 pt-4 pb-1">
    @for (tab of tabs; track tab.id) {
      @if (tab.center) {
        <div class="h-10" aria-hidden="true"></div>
      } @else {
        <a
          [routerLink]="tab.route"
          routerLinkActive="router-link-active"
          [routerLinkActiveOptions]="{ exact: tab.route === '/home' }"
          class="flex min-w-0 flex-col items-center justify-end gap-1 py-1 text-[0.7rem] font-medium leading-none !text-gray-500 no-underline [&.router-link-active]:!font-semibold [&.router-link-active]:!text-gray-900"
        >
          <ion-icon [name]="tab.icon" class="text-[1.3rem] !text-inherit [color:inherit]"></ion-icon>
          <span class="text-inherit">{{ tab.labelKey | translate }}</span>
        </a>
      }
    }
  </div>
</nav>
